export const ZChainIcon = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.42891 6.53809L6.32824 9.05889H12.6303L5.48798 17.4616H16.4114L18.5121 14.9408H11.3098L18.5121 6.53809H8.42891Z'
      fill='url(#paint0_linear_3436_32924)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_3436_32924'
        x1='6.53832'
        y1='6.53809'
        x2='17.4618'
        y2='17.4616'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' />
        <stop offset='0.5' stopColor='#999999' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
    </defs>
  </svg>
);
